import { connect } from "react-redux";
import AuthTimer from "./AuthTimer.Component";

function mapStateToProps() {
  return {};
}

function mapDispatchToProps() {
  return {
    logout: () => {
      localStorage.removeItem("admin.usr");
      window.location.reload();
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthTimer);
